import React from 'react';
import ResultPageModal, { capitalizeTitle } from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModal';

function PubblicoImpiegoModal({
  insuranceRequest,
  addingQuote,
  quotations,
  selectQuotation,
  type,
  processingQuote,
}) {
  const title = type.id === 'res_civile' && insuranceRequest.product.id === 1000
    ? 'Res. Amministrativa e Amministrativo/Contabile'
    : capitalizeTitle(type.name);

  return (
    <ResultPageModal
      type={type}
      title={title}
      insuranceRequest={insuranceRequest}
      addingQuote={addingQuote}
      quotations={quotations}
      selectQuotation={selectQuotation}
      processingQuote={processingQuote}
    />
  );
}

export default PubblicoImpiegoModal;
